export default "__VITE_ASSET__CGiq3Xsw__"